export default __webpack_public_path__ + "static/media/signin1.70997363.jpg";